import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './FilterRowDropdownItem.scss'

const FilterRowDropdownItem = props => {
  const itemClassName = classNames(
    ['FilterRowDropdownItem', ...props.itemClassName],
    {
      'FilterRowDropdownItem--active': props.active,
      'FilterRowDropdownItem--header': props.isHeader,
      'FilterRowDropdownItem--sort--inactive':props.isSort &&  !props.active,
      'FilterRowDropdownItem--sort--active':props.isSort &&  props.active

    }
  )

  let decorator
  if (props.renderDecorator) {
    decorator = props.renderDecorator()
  }

  let linkStyles = props.linkStyles
  if (props.active) {
    linkStyles = {
      ...linkStyles,
      color: props.activeLinkColor
    }
  }

  return (
    <li className={itemClassName} style={props.itemStyles} onClick={e => {
      e.preventDefault()
      props.handleItemClick()
    }}>
      <a
        style={linkStyles}
        className={props.linkClassName}
        href='#'
        
      >
        {props.label}
      </a>
      <div style={{marginLeft: 'auto'}}>{decorator}</div>
    </li>
  )
}

FilterRowDropdownItem.defaultProps = {
  itemClassName: [],
  linkStyles: {},
  activeLinkColor: '#000000'
}

FilterRowDropdownItem.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.string,
  itemClassName: PropTypes.array,
  linkClassName: PropTypes.string,
  handleItemClick: PropTypes.func,
  renderDecorator: PropTypes.func,
  isHeader: PropTypes.bool,
  linkStyles: PropTypes.object,
  itemStyles: PropTypes.object,
  filterName: PropTypes.string
}

export default FilterRowDropdownItem
